import * as React from "react";
import { cva } from "class-variance-authority";

export const boxVariants = cva("transition-colors", {
  variants: {
    variant: {
      default: "border border-border-subtle bg-surface",
      elevated: "bg-surface-elevated",
      glass: "border border-glass-border bg-glass-bg backdrop-blur-md",
      bordered: "border border-border bg-surface",
    },
    padding: {
      none: "p-0",
      sm: "p-4",
      md: "p-6",
      lg: "p-8",
      xl: "p-12",
    },
    rounded: {
      none: "rounded-none",
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg",
      xl: "rounded-xl",
      "2xl": "rounded-2xl",
      pill: "rounded-pill",
    },
  },
  defaultVariants: {
    variant: "default",
    padding: "none",
    rounded: "none",
  },
});

export interface BoxProps {
  variant?: "default" | "elevated" | "glass" | "bordered";
  padding?: "none" | "sm" | "md" | "lg" | "xl";
  rounded?: "none" | "sm" | "md" | "lg" | "xl" | "2xl" | "pill";
  children: React.ReactNode;
  className?: string;
}

export const Box = ({
  variant = "default",
  padding = "none",
  rounded = "none",
  children,
  className,
}: BoxProps) => (
  <div className={boxVariants({ variant, padding, rounded, className })}>{children}</div>
);
